module.exports = __webpack_public_path__ + "static/media/section-approvals.9339ad39.svg";